import React, { useState, useEffect } from "react";
import Footer from "../../components/Footer";

import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import { Container, TituloGuia } from "./styled";
import Modal from "react-modal";

import "react-tabs/style/react-tabs.css";
import { producaov2 } from "../../services/apis";
import {
  Table,
  Button,
  Icon,
  Message,
  Pagination,
  Grid,
  Input,
  Select,
} from "semantic-ui-react";
import swal from "sweetalert";
import Verificado from "./Verificado";
import Aprovado from "./Aprovado";
import AdminMenu from "../../components/Admin/MenuDetalhes/AdminMenu";
import { smallDateFormat } from "../../utils/Utils";


function Feedback() {
  const [projects, setProjects] = useState([]);
  const [envioInfos, setEnvioInfos] = useState([]);
  const [modalEnvio, setModalEnvio] = useState(false);
  const [loadingSend, setLoadingSend] = useState(false);
  const [error, setError] = useState("");
  const [aba, setAba] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState(1);
  const [count, setCount] = useState(1);

  useEffect(() => {
    let uri = "projetos";
    uri += `?page=${page}`;
    uri += `&status=${status}`;
    if (aba == 1) uri += "&projeto_final=1";
    if (aba == 2) uri += "&certificado_inicial=1";
    if (search != "") uri += `&search=${search}`;
    let project = [];
    let projectInfo;
    producaov2.get(uri).then(async (v) => {
      v.data.map((l) => {
        if (aba === 0) {
          if (l.nome_licao.toLowerCase().indexOf("certificado") < 0) {
            project.push(l);
          }
        } else {
          project.push(l);
        }
      });
      if (aba == 1) {
        await Promise.all(project.map(async (p, index) => {
          projectInfo = { ...p, opcao: await check_ppas_done(p.id_aluno) };
          project[index] = projectInfo;
        }))
      }
      setProjects(project);
    });
  }, [aba, page, search, status]);

  useEffect(() => {
    let uri = "projetos/count";
    uri += `?page=${page}`;
    uri += `&status=${status}`;
    if (aba == 1) uri += "&projeto_final=1";
    if (aba == 2) uri += "&certificado_inicial=1";
    if (search != "") uri += `&search=${search}`;

    producaov2
      .get(uri)
      .then(async (v) => {
        setCount(v.data);
      })
      .catch((e) => {
        setCount(0);
      });
  }, [aba, search, status]);

  async function check_ppas_done(id_pessoa) {
    let params = {
      id_aluno: id_pessoa,
      id_curso: 3462
    };

    const ppaServicos = producaov2.post('admin/certificate', {
      userId: id_pessoa,
      courseId: 3462,
      justVerification: true
    })
      .then(res => {
        return res.data.url;
      })
      .catch(err => {
        return undefined;
      });

    params = {
      id_aluno: id_pessoa,
      id_curso: 3467
    }

    const ppaIndustrial = await producaov2.post('admin/certificate', {
      userId: id_pessoa,
      courseId: 3467,
      justVerification: true
    })
      .then(res => {
        return res.data.url;
      })
      .catch(err => {
        return undefined;
      });

    if (ppaServicos && ppaIndustrial) {
      return "1";
    }

    if (!ppaServicos && !ppaIndustrial) {
      return "2";
    }

    if ((ppaServicos && !ppaIndustrial) || (!ppaServicos && ppaIndustrial)) {
      return "3";
    }
  }

  function return_name_curso(id_curso = 3462) {
    return id_curso == 3462
      ? "Projeto Prático Aplicado - Área de Serviços"
      : "Projeto Prático Aplicado - Área Industrial";
  }

  function render_header_table() {
    return (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Status</Table.HeaderCell>
          <Table.HeaderCell>Lição</Table.HeaderCell>
          <Table.HeaderCell>Data</Table.HeaderCell>
          {/* <Table.HeaderCell>Curso</Table.HeaderCell> */}
          <Table.HeaderCell>Pessoa</Table.HeaderCell>
          <Table.HeaderCell>Feedback</Table.HeaderCell>
          {/* <Table.HeaderCell>Verificação</Table.HeaderCell> */}
          <Table.HeaderCell>Arquivo do aluno</Table.HeaderCell>
          {aba == 1 && <Table.HeaderCell>Aprovado</Table.HeaderCell>}
          {aba == 1 && <Table.HeaderCell>Emitir certificado</Table.HeaderCell>}
        </Table.Row>
      </Table.Header>
    );
  }

  function sendFeedback(info) {
    setEnvioInfos(info);
    setModalEnvio(true);
  }

  function return_button_feedback(feedback, i) {
    return feedback == "" ? (
      <center>
        <button
          onClick={() => {
            sendFeedback(projects[i]);
          }}
          style={{
            padding:".3rem",
            background:"green",
            border:"1px solid #FFF",
            borderRadius:"5px",
            color:"#FFF"
          }}
        >
          Enviar
        </button>
      </center>
    ) : (
      <center>
        <a
          href={feedback.replace("var/www/html", "https://www.voitto.com.br")}
          // className="ui positive button"
        >
          Visualizar
        </a>
        <br />
        <button
          onClick={() => {
            sendFeedback(projects[i]);
          }}
          style={{
            padding:".3rem",
            background:"yellow",
            border:"1px solid #FFF",
            borderRadius:"5px"
          }}
          // className="ui yellow button"
        >
          Reenviar
        </button>
      </center>
    );
  }

  function render_table_body(arr) {
    const rows = arr.map((v, i) => (
      <Table.Row style={{fontSize:".8rem"}}>
        <Table.Cell>{v.url_feedback == "" ? "Em aberto" : "Enviado"}</Table.Cell>
        <Table.Cell>{v.nome_licao.replace("Envio da Etapa","").replace("Envio da ETAPA","").replace("Envio do Projeto","") || "Projeto"}- {return_name_curso(v.id_curso).replace("Projeto Prático Aplicado - ","")}</Table.Cell>
        <Table.Cell>
          {smallDateFormat(v.data_envio_projeto_update)}
        </Table.Cell>
        <Table.Cell>
          {v.pessoa === null || v.pessoa === undefined ? "" : v.pessoa.email}
        </Table.Cell>
        <Table.Cell>{return_button_feedback(v.url_feedback, i)}</Table.Cell>
        {/* <Table.Cell>
          <Verificado info={v} />
        </Table.Cell> */}
        <Table.Cell>
          <a
            href={v.url_projeto.replace(
              "/var/www/html",
              "https://www.voitto.com.br"
            )}
            style={{
              
            }}
          >
            Visualizar
          </a>
        </Table.Cell>
        {aba == 1 && (
          <Table.HeaderCell>
            <Aprovado info={v} />
          </Table.HeaderCell>
        )}
        {aba == 1 && (
          <Table.HeaderCell>
            <a
              href={`admin/certificados/novo?type=specialist-lean-six-sigma&userId=${v.id_aluno}`}
              target="_blank"
             
            >
              Emitir
            </a>
          </Table.HeaderCell>
        )}
      </Table.Row>
    ));

    return <Table.Body>{rows}</Table.Body>;
  }

  function render_filters() {
    return (
      <>
        <Grid stackable columns={3}>
          <Grid.Column>
            <Input
              fluid
              id="inputSearchPPAS"
              icon={
                search != "" ? (
                  <Icon
                    onClick={() => setSearch("")}
                    name="close"
                    inverted
                    circular
                    link
                  />
                ) : (
                  <Icon
                    onClick={() =>
                      setSearch(
                        document.getElementById("inputSearchPPAS").value
                      )
                    }
                    name="search"
                    inverted
                    circular
                    link
                  />
                )
              }
              placeholder="Nome ou email"
            />
          </Grid.Column>
          <Grid.Column>
            <Pagination
              defaultActivePage={1}
              activePage={page}
              onPageChange={(e, f) => setPage(f.activePage)}
              ellipsisItem={{
                content: <Icon name="ellipsis horizontal" />,
                icon: true,
              }}
              firstItem={{
                content: <Icon name="angle double left" />,
                icon: true,
              }}
              lastItem={{
                content: <Icon name="angle double right" />,
                icon: true,
              }}
              prevItem={{ content: <Icon name="angle left" />, icon: true }}
              nextItem={{ content: <Icon name="angle right" />, icon: true }}
              totalPages={Math.ceil(count / 25)}
            />
          </Grid.Column>
          <Grid.Column>
            <Select
              onChange={(e, f) => setStatus(f.value)}
              style={{ width: "70%", position: "relative", left: "30%" }}
              placeholder="Status do envio"
              options={
                aba == 1
                  ? [
                    { key: "1", value: "1", text: "Todos" },
                    { key: "2", value: "2", text: "Não aprovados" },
                    { key: "3", value: "3", text: "Aprovados" },
                  ]
                  : [
                    { key: "1", value: "1", text: "Todos" },
                    { key: "2", value: "2", text: "Em aberto" },
                    { key: "3", value: "3", text: "Enviados" },
                  ]
              }
            />
          </Grid.Column>
        </Grid>
        <p style={{ fontSize: 16 }}>{count} Resultados encontrados</p>
      </>
    );
  }

  function projetos_render() {
    return (
      <div>
        {/* {render_filters()} */}
        {/* <div style={{ overflow: 'auto', maxHeight: '500px', maxWidth: '100%'}}> */}

        <Table>
          {render_header_table()}
          {render_table_body(projects)}
        </Table>
        {/* </div> */}
        <br/>
        {render_filters()}
      </div>
    );
  }

  function finais_render() {
    return (
      <div styles={{width: "100%"}}>
        {/* {render_filters()} */}
        <div style={{ overflow: 'auto', maxHeight: '500px', maxWidth: '100%'}}>

        <Table>
          {render_header_table()}
          {render_table_body(projects)}
        </Table>
        </div>
        <br/>
        {render_filters()}
      </div>
    );
  }

  function certificados_render() {
    return (
      <div>
        {/* {render_filters()} */}
        <div style={{ overflow: 'auto', maxHeight: '500px', maxWidth: '100%'}}>

        <Table>
          {render_header_table()}
          {render_table_body(projects)}
        </Table>
        </div>
        <br/>
        {render_filters()}
      </div>
    );
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "40%",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  const uploadImage = async (e) => {
    setLoadingSend(true);
    if (
      e.target.files[0].type.indexOf("pdf") < 0 &&
      e.target.files[0].type.indexOf("xls") < 0 &&
      e.target.files[0].type.indexOf("xlsx") < 0 &&
      e.target.files[0].type.indexOf(
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) < 0
    ) {
      setError("O feedback deve estar no formato pdf ou xlsx(planilha).");
      setLoadingSend(false);
      return;
    }
    const data = new FormData();
    data.append("file", e.target.files[0]);
    data.append("nome", `${Date.now()}`);
    data.append("path", "feedbacks");
    try {
      const urlPath = await producaov2.post("upload", data);
      if (urlPath.data.url !== undefined) {
        const response = await submitProject(urlPath.data.url);
        if (response) {
          const dataEmail = {
            nome: envioInfos.pessoa.nome,
            email: envioInfos.pessoa.email,
            cc: "ti@voitto.com.br",
            assunto: envioInfos?.nome_licao,
            context: {
              nome_aluno: envioInfos.pessoa.nome,
              licao: envioInfos.nome_licao,
              id_curso: envioInfos.id_curso,
            },
            model: 59,
          };

          const emailConfirmation = await producaov2.post(
            "mail/send",
            dataEmail
          );

          setLoadingSend(false);
          setModalEnvio(false);
          swal(
            "Feedback enviado",
            "O feedback foi enviado com sucesso!",
            "success"
          );

          return;
        }
        throw new Error("Problema com PPA");
      }
      throw new Error("Ppa não enviado");
    } catch (err) {
      setLoadingSend(false);
      console.error(err);
      setError(
        "Problemas ao enviar o feedback! Tivemos um problema ao enviar seu projeto, por gentileza, tente novamente, se persistir, nos contacte",
        "error"
      );
    }
  };

  async function submitProject(file) {
    const data = envioInfos;
    console.log(envioInfos);
    data.url_feedback = file;
    const retorno = await producaov2
      .put("projetos", data)
      .then((v) => {
        console.log(v.data);
        return true;
      })
      .catch((err) => {
        setError(
          "Houve um erro ao salvar os dados do arquivo enviado. Se o erro persistir, nos contate."
        );
        return false;
      });
    return retorno;
  }

  function return_modal() {
    return (
      <Modal
        isOpen={modalEnvio}
        style={customStyles}
        onRequestClose={() => setModalEnvio(false)}
        contentLabel="Enviando feedback"
      >
        <center>
          <TituloGuia>Enviando Feedback</TituloGuia>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Curso</Table.HeaderCell>
                <Table.HeaderCell>Lição</Table.HeaderCell>
                <Table.HeaderCell>Pessoa</Table.HeaderCell>
                <Table.HeaderCell>Arquivo do aluno</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell>
                  {return_name_curso(envioInfos.id_curso)}
                </Table.Cell>
                <Table.Cell>{envioInfos.nome_licao}</Table.Cell>
                <Table.Cell>
                  {envioInfos.pessoa.nome}
                  <br />
                  {envioInfos.pessoa.email}
                </Table.Cell>
                <Table.Cell>
                  <a
                    target="_blank"
                    href={envioInfos.url_projeto.replace(
                      "var/www/html",
                      "https://www.voitto.com.br"
                    )}
                    className="ui positive button"
                  >
                    Visualizar
                  </a>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
          <Button
            icon
            labelPosition="left"
            onClick={() => document.getElementById("file").click()}
            loading={loadingSend}
            secondary
          >
            <Icon name="upload" />
            Enviar Feedback
          </Button>
          {error !== "" && (
            <Message negative>
              <Message.Header>{error}</Message.Header>
            </Message>
          )}
          <input
            type="file"
            onChange={uploadImage}
            name="file"
            id="file"
            class="inputfile"
            style={{ display: "none" }}
          />
        </center>
      </Modal>
    );
  }

  return (
    <>
      <Container>
        <Tabs
          onSelect={(index) => {
            setAba(index);
            setPage(1);
          }}
        >
          <TabList>
            <Tab>Projetos</Tab>
            <Tab>Etapas finais</Tab>
            <Tab>Certificados</Tab>
          </TabList>
          <TabPanel>{projetos_render()}</TabPanel>
          <TabPanel>{finais_render()}</TabPanel>
          <TabPanel>{certificados_render()}</TabPanel>
        </Tabs>
      </Container>
      {modalEnvio == true && return_modal()}
    </>
  );
}

export default Feedback;
